import React, { useEffect, useState, useMemo } from "react"
import { Table, Row, Col, Input, Modal, Form, Label } from "reactstrap"
import { useNavigate } from "react-router-dom"
import { useTable, usePagination, useGlobalFilter } from "react-table"
import NewPagination from "components/Common/Newpagination"
import Select from "react-select"
import {
  fetchNodeData,
  FetchNodeDeleteData,
  FetchNodePostData,
  FetchNodePutData,
} from "utils/common-fetchData"
import Loader from "pages/Separate/Loader"
import secureLocalStorage from "react-secure-storage"
import Swal from "sweetalert2"
import sampleFile from "./sampleFile2.xlsx"
import axios from "axios"
import configure from "configure"
import AccessDeniedPopup from "routes/AccessDeniedPopup"
import { TimePicker } from "antd"
import dayjs from "dayjs"
import * as XLSX from "xlsx"
import { saveAs } from "file-saver"

/* ===========================
   MODAL (UPDATED)
=========================== */
function QuestionModal({
  modal,
  setModal,
  question,
  setQuestion,
  category,
  setCategory,
  questionType,
  setQuestionType,
  options,
  setOptions,
  correctAnswer,
  setCorrectAnswer,
  duration,
  setDuration,
  questionId,
  setQuestionId,
  setImportModal,
  importModal = false,
  categoryOptions,
  handleSubmitQuestion,
  file,
  setFile,
}) {
  const handleOptionChange = (key, value) => {
    setOptions(prev => ({ ...prev, [key]: value }))
  }

  useEffect(() => {
    if (!modal) {
      setQuestion("")
      setCategory("")
      setQuestionType("")
      setDuration(dayjs("01:00", "mm:ss"))
      setOptions({ 1: "", 2: "", 3: "", 4: "" })
      setCorrectAnswer("")
      if (questionId) setQuestionId(null)
      setImportModal(false)
    }
  }, [modal])

  useEffect(() => {
    console.log("importModal: ", importModal)
  }, [importModal])

  const format = "mm:ss"

  return (
    <Modal isOpen={modal} size={importModal ? "md" : "lg"} centered>
      <div className="modal-header">
        {importModal ? (
          <h5 className="modal-title mt-0">Import Questions</h5>
        ) : (
          <h5 className="modal-title mt-0">
            {questionId ? "Edit" : "Add"} Question
          </h5>
        )}
        <button
          type="button"
          onClick={() => {
            setModal(false)
          }}
          className="btn-modal-close"
        >
          <span aria-hidden="true" className="btn-modal-span">
            &times;
          </span>
        </button>
      </div>

      <div className="modal-body">
        <Form className="row px-3" onSubmit={handleSubmitQuestion}>
          {/* QUESTION */}
          {!importModal && (
            <div className="mb-4 col-md-12">
              <Label>
                Question<span className="text-danger"> *</span>
              </Label>
              <Input
                type="text"
                className="form-control"
                placeholder="Enter Question"
                value={question}
                onChange={e => setQuestion(e.target.value)}
                required
              />
            </div>
          )}

          {/* CATEGORY */}
          <div className={`mb-4 col-md-${importModal ? "12" : "4"}`}>
            <Label>
              Category<span className="text-danger"> *</span>
            </Label>
            <Select
              type="select"
              className="basic-multi-select"
              classNamePrefix="select"
              value={category}
              onChange={setCategory}
              options={categoryOptions}
              required
            ></Select>
          </div>

          {/* QUESTION TYPE */}
          {!importModal && (
            <>
              <div className="mb-4 col-md-4">
                <Label>
                  Question Type<span className="text-danger"> *</span>
                </Label>
                <Input
                  type="select"
                  className="form-control"
                  value={questionType}
                  onChange={e => setQuestionType(e.target.value)}
                  required
                >
                  <option value="">Select Type</option>
                  <option value="1">MCQ</option>
                  <option value="2">Code Editor</option>
                  <option value="3">Text Input</option>
                </Input>
              </div>

              <div className="mb-4 col-md-4">
                <Label>
                  Duration <span className="text-danger">*</span>
                </Label>

                <TimePicker
                  value={duration} // ✅ dayjs only
                  format="mm:ss"
                  showHour={false}
                  showNow={false}
                  needConfirm={false}
                  placeholder="mm:ss"
                  className="w-100"
                  onChange={time => setDuration(time)} // ✅ keep dayjs
                />
              </div>
            </>
          )}

          {/* MCQ OPTIONS */}
          {!importModal && questionType === "1" && (
            <>
              <div className="py-3 audit_box row mx-0">
                {["1", "2", "3", "4"].map(opt => (
                  <div key={opt} className="py-2 col-md-6">
                    <Label>
                      Option {opt}
                      <span className="text-danger"> *</span>
                    </Label>
                    <Input
                      type="text"
                      placeholder={`Enter Option ${opt}`}
                      value={options[opt] || ""}
                      onChange={e => handleOptionChange(opt, e.target.value)}
                      required
                    />
                  </div>
                ))}

                <div className="mt-3 mb-2 col-md-6">
                  <Label>
                    Correct Answer<span className="text-danger"> *</span>
                  </Label>
                  <Input
                    type="select"
                    value={correctAnswer}
                    onChange={e => setCorrectAnswer(e.target.value)}
                    required
                  >
                    <option value="">Select Correct Answer</option>
                    {["1", "2", "3", "4"].map(opt => (
                      <option key={opt} value={opt}>
                        {opt}
                      </option>
                    ))}
                  </Input>
                </div>
              </div>
            </>
          )}

          {importModal && (
            <div className="mb-4 col-md-12">
              <Label>
                Upload Sheet<span className="text-danger"> *</span>
              </Label>
              <input
                type="file"
                className="form-control"
                onChange={e => setFile(e.target.files[0])}
                required
              />
            </div>
          )}

          <div className="mt-4">
            <button type="submit" className="border-radius btn btn-purple">
              <i className="fas fa-save me-2"></i>
              Submit
            </button>

            {importModal && (
              <button
                type="button"
                className="border-radius btn btn-primary ms-3"
                onClick={() => {
                  const link = document.createElement("a")
                  link.href = ""
                  link.href = sampleFile
                  link.download = "sampleFile.xlsx"
                  document.body.appendChild(link)
                  link.click()
                  document.body.removeChild(link)
                }}
              >
                <i className="fas fa-download me-2"></i>
                Sample Sheet
              </button>
            )}
          </div>
        </Form>
      </div>
    </Modal>
  )
}

const fmtCount = n => (n ?? 0).toLocaleString("en-IN")

/* ===========================
   TABLE CONTAINER (UNCHANGED + ADD COLUMN)
=========================== */
const TYPE_LABEL = { 1: "MCQ", 2: "Code Editor", 3: "Text Input" }

function handleExportCategory(data, filterCategory) {
  if (!data || data.length === 0) {
    Swal.fire({ icon: "warning", title: "No questions to export." })
    return
  }

  const rows = data.map((q, idx) => {
    let opts = {}
    if (Number(q.type) === 1 && q.options) {
      try { opts = JSON.parse(q.options) } catch (_) { opts = {} }
    }
    return {
      "No.": idx + 1,
      "Question": q.question || "",
      "Category": q.categoryname || "",
      "Type": TYPE_LABEL[Number(q.type)] || "N/A",
      "Option A": opts["1"] || "",
      "Option B": opts["2"] || "",
      "Option C": opts["3"] || "",
      "Option D": opts["4"] || "",
    }
  })

  const ws = XLSX.utils.json_to_sheet(rows)

  // Column widths
  ws["!cols"] = [
    { wch: 5 },   // No.
    { wch: 55 },  // Question
    { wch: 20 },  // Category
    { wch: 14 },  // Type
    { wch: 30 },  // Option A
    { wch: 30 },  // Option B
    { wch: 30 },  // Option C
    { wch: 30 },  // Option D
  ]

  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, "Questions")

  const catName = filterCategory?.label
    ? filterCategory.label.replace(/[^a-z0-9_\- ]/gi, "").trim()
    : "All"
  const fileName = `Questions_${catName}.xlsx`

  const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" })
  saveAs(new Blob([wbout], { type: "application/octet-stream" }), fileName)
}

function TableContainer({
  columns,
  data,
  question,
  setQuestion,
  category,
  setCategory,
  questionType,
  setQuestionType,
  options,
  setOptions,
  correctAnswer,
  setCorrectAnswer,
  duration,
  setDuration,
  categoryOptions,
  handleSubmitQuestion,
  modal,
  setModal,
  questionId,
  setImportModal,
  importModal,
  file,
  setFile,
  canAdd,
  onAddPermission,
  onImportPermission,
  filterCategory,
  setFilterCategory,
  filterType,
  setFilterType,
  totalCount,
  allCategoryOptions,
  typeCounts,
}) {
  const [fixedContent, setFixedContent] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 160) {
        setFixedContent(true)
      } else {
        setFixedContent(false)
      }
    }

    document.addEventListener("scroll", handleScroll)
    return () => document.removeEventListener("scroll", handleScroll)
  }, [])

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    prepareRow,
  } = useTable({ columns, data, initialState: { pageSize: 100 } }, useGlobalFilter, usePagination)

  const { pageIndex, pageSize, globalFilter } = state

  return (
    <div className="px-2">
      {/* FIXED BUTTONS */}
      <div
        className={`flex-column fixed-buttons ${fixedContent ? "d-flex" : "d-none"
          }`}
      >
        {canAdd && (
          <button
            onClick={onAddPermission}
            className="btn btn-purple border-radius fix-btn"
          >
            <i className="fas fa-plus me-2"></i>
            <span>Service</span>
          </button>
        )}

        <button
          onClick={() => navigate(-1)}
          className="btn btn-red border-radius fix-btn"
        >
          <i className="dripicons-cross me-2 icon-center"></i>
          <span>Cancel</span>
        </button>
      </div>

      {/* TABLE + FILTERS */}
      <Row className="mb-2">
        <Col lg={2}>
          <select
            className="border-radius form-select"
            style={{ width: "150px" }}
            value={pageSize}
            onChange={e => setPageSize(Number(e.target.value))}
          >
            {[100, 250, 500, 1000].map(size => (
              <option key={size} value={size}>
                Show {size}
              </option>
            ))}
          </select>
        </Col>

        <Col className="d-flex justify-content-end">
          <div className="me-4">
            <div className="search-box d-inline-block">
              <div className="position-relative">
                <input
                  onChange={e => setGlobalFilter(e.target.value)}
                  type="text"
                  className="border-radius form-control"
                  placeholder="Search..."
                  value={globalFilter || ""}
                />
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>

          <div>
            {canAdd && (
              <button
                className="border-radius btn btn-success"
                onClick={onImportPermission}
              >
                <i className="fas fa-download me-2 icon-size"></i>Import
              </button>
            )}
            <button
              className="border-radius btn btn-info ms-2"
              onClick={() => handleExportCategory(data, filterCategory)}
              title={filterCategory ? `Export "${filterCategory.label}" questions` : "Export all questions"}
            >
              <i className="fas fa-file-excel me-2 icon-size"></i>
              Export{filterCategory ? ` (${filterCategory.label})` : ""}
            </button>
            {canAdd && (
              <button
                className="border-radius btn btn-purple ms-2"
                onClick={onAddPermission}
              >
                <i className="fas fa-plus me-2 icon-size"></i>Question
              </button>
            )}
            <button
              className="border-radius btn text-white ms-md-2 btn-red"
              onClick={() => navigate(-1)}
            >
              <i className="dripicons-cross me-2 icon-center"></i>Cancel
            </button>
          </div>
        </Col>
      </Row>

      {/* FILTERS + STATS */}
      <div className="my-3 d-flex justify-content-between align-items-center gap-3" style={{ background: "#fafafa", border: "1px solid #ece8f5", borderRadius: 10, padding: "10px 16px" }}>

        {/* Type-wise stats — always visible */}
        <div className="d-flex align-items-center gap-2">
          {[
            { label: "Total",       color: "#752a97", bg: "#f5eeff", icon: "fas fa-layer-group"   , count: typeCounts?.total ?? totalCount },
            { label: "MCQ",         color: "#1a73e8", bg: "#eaf1ff", icon: "fas fa-check-circle"  , count: typeCounts?.mcq   ?? 0 },
            { label: "Code Editor", color: "#e67e22", bg: "#fff4e6", icon: "fas fa-code"           , count: typeCounts?.code  ?? 0 },
            { label: "Text Input",  color: "#27ae60", bg: "#edfbf3", icon: "fas fa-pen-nib"        , count: typeCounts?.text  ?? 0 },
          ].map(({ label, color, bg, icon, count }) => (
            <div key={label} style={{ display: "flex", alignItems: "center", gap: 10, background: "#fff", border: `1.5px solid ${color}30`, borderRadius: 10, padding: "7px 14px", boxShadow: "0 1px 4px rgba(0,0,0,0.05)" }}>
              <div style={{ width: 32, height: 32, borderRadius: 8, background: bg, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                <i className={icon} style={{ color, fontSize: 13 }}></i>
              </div>
              <div style={{ lineHeight: 1.25 }}>
                <div style={{ fontSize: 10, color: "#888", fontWeight: 500 }}>{label}</div>
                <div style={{ fontSize: 14, fontWeight: 800, color }}>{fmtCount(count)}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Filter controls row */}
        <div className="d-flex align-items-center gap-2 flex-wrap">
          <div style={{ minWidth: 220 }}>
            <Select
              isClearable
              placeholder="Category..."
              value={filterCategory}
              onChange={setFilterCategory}
              options={allCategoryOptions}
              classNamePrefix="select"
              styles={{
                control: base => ({ ...base, borderRadius: 6, borderColor: "#d0c4e8", minHeight: 36, fontSize: 13 }),
                valueContainer: base => ({ ...base, padding: "0 8px" }),
              }}
            />
          </div>
          <select
            className="form-select border-radius"
            style={{ width: 150, fontSize: 13, height: 36 }}
            value={filterType}
            onChange={e => setFilterType(e.target.value)}
          >
            <option value="">All Types</option>
            <option value="1">MCQ</option>
            <option value="2">Code Editor</option>
            <option value="3">Text Input</option>
          </select>
          {(filterCategory || filterType !== "") && (
            <button
              className="btn btn-sm rounded-4 btn-red"
              onClick={() => { setFilterCategory(null); setFilterType("") }}
            >
              <i className="fas fa-times"></i>
            </button>
          )}
          {/* {filterCategory && (
            <span style={{ fontSize: 12, color: "#752a97", fontWeight: 600, marginLeft: 4 }}>
              <i className="fas fa-filter me-1"></i>{filterCategory.label}
            </span>
          )} */}
        </div>
      </div>

      {/* TABLE */}
      <Table className="table table-bordered mt-2" {...getTableProps()}>
        <thead className={fixedContent ? "fixed-setting-header" : ""}>
          {headerGroups.map((hg, i) => (
            <tr key={i} {...hg.getHeaderGroupProps()}>
              {hg.headers.map((col, idx) => (
                <th
                  key={idx}
                  {...col.getHeaderProps()}
                  className={col.className}
                >
                  {col.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row)
            return (
              <tr key={i} {...row.getRowProps()}>
                {row.cells.map((cell, idx) => (
                  <td key={idx} {...cell.getCellProps()}>
                    {cell.render("Cell")}
                  </td>
                ))}
              </tr>
            )
          })}
        </tbody>
      </Table>

      {/* PAGINATION */}
      <Row className="justify-content-md-end justify-content-center">
        <NewPagination
          gotoPage={gotoPage}
          canPreviousPage={canPreviousPage}
          previousPage={previousPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
          pageSize={pageSize}
          page={page}
          data={data}
          nextPage={nextPage}
        />
      </Row>

      {/* MODAL */}
      <QuestionModal
        modal={modal}
        setModal={setModal}
        question={question}
        setQuestion={setQuestion}
        category={category}
        setCategory={setCategory}
        questionType={questionType}
        setQuestionType={setQuestionType}
        options={options}
        setOptions={setOptions}
        correctAnswer={correctAnswer}
        setCorrectAnswer={setCorrectAnswer}
        duration={duration}
        setDuration={setDuration}
        setImportModal={setImportModal}
        importModal={importModal}
        categoryOptions={categoryOptions}
        handleSubmitQuestion={handleSubmitQuestion}
        questionId={null}
        file={file}
        setFile={setFile}
      />
    </div>
  )
}

/* ===========================
   MAIN COMPONENT (FINAL)
=========================== */
const ASSESSMENT_MODULE_ID = 122

const QuestionsList = () => {
  const [modal_Access, setAccessDenied] = useState(false)
  const [permissions, setPermissions] = useState({ canAdd: false, canEdit: false, canDelete: false })
  const [data, setData] = useState([])

  const [modal, setModal] = useState(false)
  const [editId, setEditId] = useState(null)
  const [question, setQuestion] = useState("")
  const [category, setCategory] = useState("")
  const [questionType, setQuestionType] = useState("")
  const [duration, setDuration] = useState(dayjs("01:00", "mm:ss"))
  const [options, setOptions] = useState({ 1: "", 2: "", 3: "", 4: "" })
  const [correctAnswer, setCorrectAnswer] = useState("")
  const [loading, setLoading] = useState(false)
  const [importModal, setImportModal] = useState(false)
  const [file, setFile] = useState(null)
  const [categoryOptions, setCategoryOptions] = useState([])
  const [filterCategory, setFilterCategory] = useState(null)
  const [filterType, setFilterType] = useState("")

  const checkPermission = (index, callback) => {
    const allowed =
      index === 3 ? permissions.canAdd :
      index === 4 ? permissions.canEdit :
      index === 5 ? permissions.canDelete : false
    if (allowed) callback()
    else setAccessDenied(true)
  }

  const fetchPermissions = async () => {
    const formData = new FormData()
    formData.append("user_id", localStorage.getItem("auth_id"))
    formData.append("module_id", ASSESSMENT_MODULE_ID)
    try {
      const res = await axios({
        method: "post",
        url: `${configure.apiUrl}/earth_permission`,
        data: formData,
        headers: { Accept: "application/json", "Content-Type": "multipart/form-data" },
      })
      const india = res.data.data.india
      const uk = res.data.data.uk
      setPermissions({
        canAdd: india[3] == 1 || uk[3] == 1,
        canEdit: india[4] == 1 || uk[4] == 1,
        canDelete: india[5] == 1 || uk[5] == 1,
      })
    } catch (e) {
      console.log(e)
    }
  }

  const fetchCategoryOptions = async () => {
    try {
      const response = await fetchNodeData(
        null,
        "preassesment/category/getAllCategory",
        secureLocalStorage?.getItem("auth_token")
      )
      const list = response?.data
      if (Array.isArray(list)) {
        setCategoryOptions(list.map(item => ({ value: item.id, label: item.name })))
      }
    } catch (e) {
      console.error("fetchCategoryOptions:", e)
    }
  }

  const fetchQuestions = async () => {
    try {
      const userId = localStorage.getItem("auth_id")
      const response = await fetchNodeData(
        null,
        `preassesment/questions/getQuestions/${userId}`,
        secureLocalStorage?.getItem("auth_token")
      )
      const list = response?.data
      if (Array.isArray(list)) setData(list)
    } catch (e) {
      console.error("fetchQuestions:", e)
    }
  }

  const handleDeleteQuestions = async id => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
      })

      if (!result.isConfirmed) return

      const response = await FetchNodeDeleteData(
        setLoading,
        "preassesment/questions/deleteQuestion",
        id
      )

      const success =
        response?.data?.success ||
        response?.data?.data?.success ||
        response?.success

      if (success) {
        await Swal.fire("Success", "Question deleted successfully", "success")
        fetchQuestions()
      } else {
        Swal.fire("Error", "Failed to delete question", "error")
      }
    } catch (error) {
      console.error(error)
      Swal.fire("Error", "Something went wrong", "error")
    }
  }
  const typeMap = {
    1: "MCQ",
    2: "Code Editor",
    3: "Text Input",
  }

  const columns = useMemo(
    () => [
      { Header: "ID", accessor: "id", className: "text-center" },
      { Header: "Question", accessor: "question", className: "col-5" },
      { Header: "Category", accessor: "categoryname" },
      {
        Header: "Type",
        accessor: "type",
        Cell: ({ row }) => typeMap[Number(row.original.type)] || "N/A",
      },
      {
        Header: "Action",
        Cell: ({ row }) => (
          <div>
            {permissions.canEdit && (
              <button
                className="btn btn-sm me-1 btn-outline-secondary"
                onClick={() => {
                  checkPermission(4, () => {
                    const q = row.original
                    setEditId(q.id)
                    setQuestion(q.question)
                    setCategory({ value: q.category, label: q.categoryname })
                    setQuestionType(String(q.type))
                    setDuration(
                      q.duration
                        ? dayjs(q.duration, "mm:ss")
                        : dayjs("01:00", "mm:ss")
                    )
                    setOptions(
                      q.options
                        ? JSON.parse(q.options)
                        : { 1: "", 2: "", 3: "", 4: "" }
                    )
                    setCorrectAnswer(String(q.correct_ans))
                    setModal(true)
                  })
                }}
              >
                <i className="fas fa-pencil-alt"></i>
              </button>
            )}
            {permissions.canDelete && (
              <button
                className="btn btn-sm btn-danger"
                onClick={() => checkPermission(5, () => handleDeleteQuestions(row.original.id))}
              >
                <i className="fas fa-trash-alt"></i>
              </button>
            )}
          </div>
        ),
      },
    ],
    [permissions]
  )

  useEffect(() => {
    const load = async () => {
      setLoading(true)
      await Promise.all([fetchQuestions(), fetchCategoryOptions(), fetchPermissions()])
      setLoading(false)
    }
    load()
  }, [])

  const handleSubmitQuestion = async e => {
    e.preventDefault()

    const payload = {
      question,
      category: category?.value,
      type: parseInt(questionType),
      duration: duration ? duration.format("mm:ss") : "01:00",
      options: JSON.stringify(options),
      correct_ans: correctAnswer,
    }

    try {
      let response

      if (importModal) {
        response = await axios.post(
          `${configure.nodeApi}/preassesment/questions/bulk`,
          { file, category: category?.value },
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
      } else if (editId) {
        // ===== EDIT MODE =====
        response = await FetchNodePutData(
          setLoading,
          `preassesment/questions/editQuestion`,
          editId,
          payload
        )
      } else {
        // ===== ADD MODE =====
        response = await FetchNodePostData(
          setLoading,
          "preassesment/question/add",
          secureLocalStorage?.getItem("auth_token"),
          { ...payload, user_id: localStorage.getItem("auth_id") }
        )
      }

      const success =
        response?.data?.success ||
        response?.data?.data?.success ||
        response?.success

      if (success) {
        Swal.fire(
          "Success",
          editId
            ? "Question updated successfully"
            : response?.data?.data?.message || response?.data?.message || "Question added successfully",
          "success"
        )

        setModal(false)
        fetchQuestions()
      } else {
        Swal.fire("Error", "Operation failed", "error")
      }
    } catch (err) {
      console.error(err)
      Swal.fire("Error", "Something went wrong", "error")
    }
  }

  const filteredData = useMemo(() => {
    let result = data || []
    if (filterCategory?.value) {
      result = result.filter(q => String(q.category) === String(filterCategory.value))
    }
    if (filterType !== "") {
      result = result.filter(q => String(q.type) === filterType)
    }
    return result
  }, [data, filterCategory, filterType])

  const typeCounts = useMemo(() => {
    const base = filterCategory?.value
      ? (data || []).filter(q => String(q.category) === String(filterCategory.value))
      : (data || [])
    return {
      total: base.length,
      mcq: base.filter(q => String(q.type) === "1").length,
      code: base.filter(q => String(q.type) === "2").length,
      text: base.filter(q => String(q.type) === "3").length,
    }
  }, [data, filterCategory])

  return (
    <div>
      {loading && <Loader />}
      <Row>
        <Col lg={12} className="p-0">
          <TableContainer
            columns={columns}
            data={filteredData}
            question={question}
            setQuestion={setQuestion}
            category={category}
            setCategory={setCategory}
            questionType={questionType}
            setQuestionType={setQuestionType}
            duration={duration}
            setDuration={setDuration}
            options={options}
            setOptions={setOptions}
            correctAnswer={correctAnswer}
            setCorrectAnswer={setCorrectAnswer}
            categoryOptions={categoryOptions}
            handleSubmitQuestion={handleSubmitQuestion}
            questionId={editId}
            modal={modal}
            setModal={setModal}
            importModal={importModal}
            setImportModal={setImportModal}
            file={file}
            setFile={setFile}
            canAdd={permissions.canAdd}
            onAddPermission={() => checkPermission(3, () => setModal(true))}
            onImportPermission={() => checkPermission(3, () => { setImportModal(true); setModal(true) })}
            filterCategory={filterCategory}
            setFilterCategory={setFilterCategory}
            filterType={filterType}
            setFilterType={setFilterType}
            totalCount={filteredData.length}
            allCategoryOptions={categoryOptions}
            typeCounts={typeCounts}
          />
        </Col>

        <QuestionModal
          modal={modal}
          setModal={setModal}
          question={question}
          setQuestion={setQuestion}
          category={category}
          setCategory={setCategory}
          questionType={questionType}
          setQuestionType={setQuestionType}
          options={options}
          setOptions={setOptions}
          duration={duration}
          setDuration={setDuration}
          correctAnswer={correctAnswer}
          setCorrectAnswer={setCorrectAnswer}
          questionId={editId}
          setQuestionId={setEditId}
          categoryOptions={categoryOptions}
          handleSubmitQuestion={handleSubmitQuestion}
          importModal={importModal}
          setImportModal={setImportModal}
          file={file}
          setFile={setFile}
        />
      </Row>

      <AccessDeniedPopup
        modal_Access={modal_Access}
        setAccessDenied={setAccessDenied}
      />
    </div>
  )
}

export default QuestionsList
